import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import OfferTemplate from './OfferTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';

OfferManageDialog.propTypes = {
  offer: PropTypes.object.isRequired
};

export default function OfferManageDialog(props) {
  const { offer } = props;

  if (offer.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="max-w-screen-lg">
      <CloseDialogButton onClick={props.onClose} />
      <div className="px-6 pt-16 pb-6">
        <OfferTemplate offer={offer} />
      </div>
    </DialogTemplate>
  );
};
